module.exports = __webpack_public_path__ + "img/download-mac-app-btn.73e02290.png";